import { Mapper } from "../../../../../core/base";
import { JobTemplateWebEntity } from "./job-template-web-entity";
import { JobTemplate } from "planning-portal-library/src/lib/core/domain";

export class JobTemplateWebRepositoryMapper extends Mapper<JobTemplateWebEntity, JobTemplate> {
  mapFrom(param: JobTemplateWebEntity): JobTemplate {
    return {
      id: param.id,
      name : param.name
    };
  }

  mapTo(param: JobTemplate): JobTemplateWebEntity {
    return {
      id: param.id,
      name : param.name
    };
  }
}
